import React, { Component } from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import { Swiper as SwiperCore, Navigation } from "swiper";
import CloseIcon from "@assets/Close.svg";

import "@styles/react-components/photoswiper.scss";

SwiperCore.use([Navigation]);

class PhotoSwiperZoom extends Component {
    constructor({items}){
      super();

      this.state = {
        open:false,
        items:items
      }
    }

    renderSwiperSlides = () => {
      const swiperNodes = this.state.items.map((item, index)=>{
        const {src, title, originalSrc, aspect} = item;
        const windowAspect = window.innerWidth / window.innerHeight;

        let styleHeight, styleWidth;
        if(aspect < windowAspect){
          styleHeight = window.innerHeight * .9;
          styleWidth = styleHeight * aspect;
        }else{
          styleWidth = window.innerWidth * .9;
          styleHeight = styleWidth / aspect;
        }

        switch(item.type){
          case "image":
            return (<SwiperSlide key={`photo-zoom-slide-${index}`}>
                        <div className="photo-swiper-zoom__img lazyload" alt={title}>
                          <img src={src} loading="lazy" />
                        </div>
                    </SwiperSlide>);
           case "iframe":
             return (<SwiperSlide key={`photo-zoom-slide-${index}`}>
                        <div className="video-wrapper" >
                          <iframe className="photo-swiper-zoom__img lazyload" loading="lazy" src={src} alt={title} width="1920" height="1080" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
                     </SwiperSlide>);
           default:
            return null;
        }
      });
      return swiperNodes;
    }

    open = ({initialSlideMediaId,filterClass})=>{

      const items = this.filterItems(filterClass);
      let initialSlide = 0;
      items.forEach((item, index)=>{
        if ( item.mediaId == initialSlideMediaId ) initialSlide = index;
      });
      this.setState({
        open: true,
        initialSlide: initialSlide,
        items: items
      });
    }

    filter = (filterClass) => {
      this.setState({
        items: this.filterItems(filterClass)
      });
    }

    filterItems = (filterClass) => {
      if( !filterClass ){
        return [...this.props.items]
      }else{
        const items = this.props.items.filter((item)=>{
          return item.classes.indexOf(filterClass) > -1;
        });
        return items;
      }
    }

    handleBackgroundClick = (e) => {
        if(e.target.className.indexOf('swiper-slide') > -1 || e.target.className.indexOf('swiper-slide') > -1){
          this.setState({
            open: false
          })
        }
    }

    render(){
      const { open, initialSlide } = this.state;

      const swiperNodes = this.renderSwiperSlides();

      return (open &&
        <div className="photo-swiper-zoom" onClick={this.handleBackgroundClick}>
          <div className="close-button" onClick={()=>{this.setState({open:false})}}>
            <CloseIcon />
          </div>
          <Swiper navigation initialSlide={initialSlide} loop>
            {swiperNodes}
          </Swiper>
        </div>
      );
    }
}

export default PhotoSwiperZoom;
